import { z } from 'zod';

export const RESULTADO_VISITA = ['NO_ENCONTRADO', 'VOLVERA', 'DEPOSITARA', 'PAGO', 'OTRO'] as const;
export type ResultadoVisita = (typeof RESULTADO_VISITA)[number];

export function fechaHoy(): string {
  const now = new Date();
  const local = new Date(now.getTime() - now.getTimezoneOffset() * 60_000);
  return local.toISOString().slice(0, 10);
}

export const CreateVisitaDtoSchema = z.object({
  idCliente: z.coerce.number().int(),
  resultado: z.enum(RESULTADO_VISITA),
  comentario: z.string().optional(),
  fecha: z
    .string()
    .optional()
    .default(() => fechaHoy()),
});

export type CreateVisitaDto = z.infer<typeof CreateVisitaDtoSchema>;

export const QueryVisitasDtoSchema = z.object({
  offset: z.coerce.number().int().min(0).default(0),
  limit: z.coerce.number().int().min(1).max(100).default(20),
  idCliente: z.coerce.number().int().optional(),
  idUsuario: z.string().uuid().optional(),
  fechaDesde: z.string().optional(),
  fechaHasta: z.string().optional(),
  resultado: z.enum(RESULTADO_VISITA).optional(),
});

export type QueryVisitasDto = z.infer<typeof QueryVisitasDtoSchema>;
